/** Sort workspace widgets by API display_order (fallback: id). */
export function sortWelcomeGroupWidgets(widgets) {
  if (!Array.isArray(widgets) || widgets.length === 0) {
    return [];
  }
  return [...widgets].sort((a, b) => {
    const ao = Number(a?.display_order);
    const bo = Number(b?.display_order);
    const aOrder = Number.isFinite(ao) ? ao : Number.MAX_SAFE_INTEGER;
    const bOrder = Number.isFinite(bo) ? bo : Number.MAX_SAFE_INTEGER;
    if (aOrder !== bOrder) {
      return aOrder - bOrder;
    }
    return Number(a?.id ?? 0) - Number(b?.id ?? 0);
  });
}

export function withWelcomeWidgetDisplayOrder(widgets) {
  return (widgets || []).map((w, index) => ({
    ...w,
    display_order: index,
  }));
}
